import { loadStripe } from "@stripe/stripe-js";
import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import {
  Stripe,
  StripeElements,
  StripeCardElementChangeEvent,
} from "@stripe/stripe-js";
import React, { RefObject, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { currentUser } from "store/ducks/user";
import { dispatchSetUser } from "store/dispatch/user.dispatch";


import { getBitsRequest } from "pages/map/services/services";
// import { StripeCard } from "../types/types";
import { onAddCardSubmitHandler, retriveCustomerPaymentMethodsHandler } from "pages/payment/utils/utils";
import { StripeCard } from "pages/payment/types/types";
import {
  addNewPurchasedBitRequest,
  createPaymentIntentRequest,
  createStripeCustomerRequest,
  createStripePaymentRecordRequest,
  retriveCustomerPaymentMethodsRequest
} from "pages/payment/services/services";
import { sendGiftBitRequest } from "../services/services";


const GiftBitPaymentForm = ({
  setFormStep,
  selectedValue,
  setPaymentCompleted,
  setPaymentFailed,
  setTransactionId,
  setTransactionAmount,
  receiverUserId,
}: {
  setFormStep: Function;
  selectedValue: any;
  setPaymentCompleted: Function;
  setPaymentFailed: Function;
  setTransactionId: Function;
  setTransactionAmount: Function | any;
  receiverUserId: any;
}) => {
  const images: { [key: string]: string } = {
    amex: "./images/americanExpress.png",
    jcb: "./images/jcb.png",
    mastercard: "./images/mastercard.png",
    visa: "./images/visa.png",
  };
  const stripe: Stripe | null = useStripe();
  const user = useSelector(currentUser);
  const elements: StripeElements | null = useElements();
  const [nameFieldValue, setNameFieldValue] = useState<string>("");
  const [customerId, setCustomerId] = useState<string | null>(null);
  const [paymentCard, setPaymentCard] = useState<StripeCard | null>(null);
  const [customerPaymentMethods, setCustomerPaymentMethods] = useState<
    StripeCard[] | null
  >(null);
  const [paymentMethod, setPaymentMethod] = useState<{
    paymentMethod: StripeCard;
  } | null>(null);
  const [disablePayment, setDisablePayment] = useState<boolean>(false);
  const [cardInfo, setCardInfo] = useState<StripeCardElementChangeEvent | null>(
    null
  );

  const fetchCardDetail = (data: StripeCardElementChangeEvent) => {
    if (data.complete) {
      setCardInfo(data);
    } else {
      setCardInfo(null);
    }
  };

  const cardOptions: {
    style: {
      base: {
        margin: "5px";
        fontSize: "16px";
        color: "#424770";
        "::placeholder": {
          color: "#aab7c4";
        };
      };
    };
    classes: {
      base: "w-full p-1";
      invalid: "text-red";
    };
    disableLink: true;
    hidePostalCode: true;
  } = {
    style: {
      base: {
        margin: "5px",
        fontSize: "16px",
        color: "#424770",
        "::placeholder": {
          color: "#aab7c4",
        },
      },
    },
    classes: {
      base: "w-full p-1",
      invalid: "text-red",
    },
    disableLink: true,
    hidePostalCode: true,
  };

  useEffect(() => {
    if (user.customer_id) {
      setCustomerId(user.customer_id);
    }
  }, []);

  useEffect(() => {
    if (user.customer_id && customerId) {
      retriveCustomerPaymentMethodsHandler(
        user.customer_id,
        retriveCustomerPaymentMethodsRequest,
        setCustomerPaymentMethods
      );
    }
  }, [paymentMethod, customerId]);

  const onPaymentSubmitHandler = async () => {
    const confirmPaymentButton = document.querySelector(
      "#confirmPayment"
    ) as HTMLButtonElement;
    confirmPaymentButton!.disabled = true;

    setDisablePayment(true);
    if (paymentCard) {
      const res: any = await createPaymentIntentRequest({
        user_id: user?.id,
        payment_method_id: paymentCard.id,
        amount: 10,
      });
      if (res) {
        if (res.data.intent.client_secret) {
          const clientSecret = res.data.intent.client_secret;
          const stripeResult = await stripe!.confirmCardPayment(clientSecret);
          if (stripeResult.error) {
            const response = await createStripePaymentRecordRequest({
              user_id: user?.id,
              payment_reference_id: res?.data?.intent?.id,
              payment_method_id: paymentCard.id,
              status: "FAIL",
              isGift: true,
            });
            setPaymentFailed(true);
            confirmPaymentButton!.disabled = false;
            setDisablePayment(false);
            setFormStep("step4")
          } else if (stripeResult.paymentIntent) {
            const response: any = await createStripePaymentRecordRequest({
              user_id: user?.id,
              payment_reference_id: res?.data?.intent?.id,
              payment_method_id: paymentCard.id,
              status: "DONE",
              amount: 10,
              isGift: true,
            });
            if (response) {
              const giftBitResponse: any = await sendGiftBitRequest({
                user: user.id,
                receiver_user_id: Number(receiverUserId),
                bit_id: Number(selectedValue),
              });
              if (giftBitResponse.success === true) {
                setTransactionId(stripeResult.paymentIntent.id);
                setPaymentCompleted(true);
                setTransactionAmount(response.data.payment_data.amount);
                setDisablePayment(false);
                confirmPaymentButton!.disabled = false;
                setFormStep("step4")
              }
            } else {
              setPaymentFailed(true);
              setDisablePayment(false);
              confirmPaymentButton!.disabled = false;
              setFormStep("step4")
            }
          }
        } else {
          setPaymentFailed(true);
          setDisablePayment(false);
          confirmPaymentButton!.disabled = false;
        }
      } else {
        setPaymentFailed(true);
        setDisablePayment(false);
        confirmPaymentButton!.disabled = false;
      }
    }
  }

  return (
    <>
      <div className="input-content mb-5 grid grid-cols-1 gap-3.5">
        <div className="form-group">
          <input
            type="text"
            className="border border-blackM/10 p-4 rounded-md placeholder:text-[#b6c1cd] focus:outline-none w-full text-base font-normal leading-[17.6px] bg-white/60 text-black  ring-2 ring-transparent focus:ring-black/10 focus:ring-offset-2 transition-all duration-300 disabled:bg-black/5 disabled:cursor-not-allowed  "
            name="name"
            placeholder="Enter Name"
            onChange={(e) => {
              setNameFieldValue(e.target.value);
            }}
            value={nameFieldValue}
          />
        </div>

        <div className="border border-blackM/10 p-4 rounded-md placeholder:text-darkgray focus:outline-none w-full text-base font-normal leading-[17.6px] bg-white text-black  ring-2 ring-transparent focus:ring-black/10 focus:ring-offset-2 transition-all duration-300 disabled:bg-black/5 disabled:cursor-not-allowed ">
          <CardElement
            onChange={(cardDetails) => {
              fetchCardDetail(cardDetails);
            }}
            options={cardOptions}
          />
        </div>
      </div>
      <div className="flex items-center justify-start gap-4 !mt-5">
        <button
          className={`mb-5 text-base max-w-48 w-full font-normal text-black hover:bg-opacity-80 rounded-full transition-all duration-300 border  px-8 py-2.5     ${cardInfo && nameFieldValue !== ""
            ? "bg-skyblue border-skyblue "
            : "bg-gray-300 border-gray-300 text-white cursor-not-allowed"
            } `}
          onClick={(e) => {
            onAddCardSubmitHandler(
              cardInfo,
              nameFieldValue,
              user,
              elements,
              stripe,
              setPaymentMethod,
              setNameFieldValue,
              createStripeCustomerRequest,
              setCustomerId,
              dispatchSetUser,
              retriveCustomerPaymentMethodsRequest,
              setCustomerPaymentMethods
            );
          }}
          disabled={!cardInfo && nameFieldValue !== ""}
        >
          Add Card
        </button>
      </div>{" "}
      <label>
        <div className="max-h-[150px] overflow-y-auto  pr-2 ">
          {customerPaymentMethods &&
            customerPaymentMethods?.map((card: StripeCard, index: number) => {
              return (
                <div
                  key={index}
                  className="bg-lightgray border border-[#6C778B1A]/10 py-2 px-4 rounded-md flex sm:flex-nowrap flex-wrap gap-2 sm:gap-6 items-center text-left mb-2"
                >
                  <div className="w-[50px] min-w-[50px] h-auto max-h-[50px] sm:order-1 order-2 ">
                    <img
                      src={`${images[`${card?.card.brand}`]}`}
                      className=""
                      alt="Stripe Logo"
                    />
                  </div>
                  <div className="grow  sm:order-2 order-3 sm:w-auto w-full ">
                    <div className="flex gap-4 mb-2">
                      <h6 className="text-base font-medium leading-[110%] ">
                        {card?.billing_details?.name}
                      </h6>
                      <h6 className="text-base font-medium leading-[110%] ">
                        {card?.card?.brand}
                      </h6>
                      <h6 className="text-base font-medium leading-[110%]  ">
                        ***{card?.card?.last4}
                      </h6>
                    </div>
                    <div className="flex gap-4">
                      <p className="text-sm font-medium leading-[110%]">
                        <span className="pr-3">Expires</span>
                        <span>
                          {card?.card?.exp_month}/{card?.card?.exp_year}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className=" sm:order-3 order-1 mr-2 sm:mr-0">
                    <input
                      type="checkbox"
                      className="  paymentGateway-Checkbox bg-white border border-[#6C778B1A]/50  w-6 h-6 cursor-pointer appearance-none rounded-md relative  after:absolute after:top-1.5 after:left-1.5 after:w-3 after:h-1.5 after:border-l-2 after:border-b-2 after:border-black after:-rotate-45  after:checked:visible after:invisible "
                      checked={
                        paymentCard === null ? false : paymentCard.id === card.id
                      }
                      onChange={() => {
                        if (paymentCard?.id === card.id) {
                          setPaymentCard(null);
                        } else {
                          setPaymentCard(card);
                        }
                      }}
                    />
                  </div>
                </div>
              );
            })}
        </div>
      </label>
      <div className="mt-0">
        <img
          src={`${process.env.REACT_APP_FRONTEND_URL}/images/paymentGateway.png`}
          className="mt-0"
          alt="Stripe Logo"
        />
      </div>
      <p className="text-xs">
        Direct secure payments supplied by{" "}
        <a href="https://stripe.com" target="_blank" className="font-bold">
          Stripe.com
        </a>
        <br />
        No card details are stored on myBitofit.com
      </p>
      <div className="flex items-center justify-end gap-4 mt-5">
        <button
          className="  border-[border-image-source:_linear-gradient(112.55deg,_rgba(0,_51,_140,_0.2)_-36.09%,_rgba(13,_2,_56,_0.2)_74.72%)] border text-base   font-normal text-black/80 hover:text-black rounded-full  transition-all duration-300 px-8 py-2.5"
          onClick={() => {
            setFormStep("step2")
          }}
        >
          Back
        </button>
        <button
          className={`  text-base font-normal hover:bg-opacity-80 rounded-full transition-all duration-300 border px-8 py-2.5 ${paymentCard && !disablePayment
            ? "bg-skyblue border-skyblue cursor-pointer text-black shadow-[0px_4px_4px_0px_#01D9FF40] "
            : "bg-gray-300 border-gray-300 text-white cursor-not-allowed "
            } `}
          disabled={!paymentCard && disablePayment}
          onClick={(e) => {
            onPaymentSubmitHandler()
          }}
          id="confirmPayment"
        >
          Pay Now
        </button>
      </div>
    </>
  );
};


export default GiftBitPaymentForm

